import React from "react";
import vtLogo from "../Assets/Images/vt-purple-logo.png";

const DmiPortfolio = () => {
  return (
    <>
      <div className="container">
        <img
          className="img-fluid mt-4 mb-1"
          src={vtLogo}
          style={{ margin: "auto", display: "block", width: "180px" }}
          alt="Vidyuttech logo"
        />

        <h5 style={{ color: "#7225F5" }} className="text-center mb-4">
          Vidyut Green Labs
        </h5>

        <section>
          <div className="row my-5">
            <div className="col-12">
              <h2 className="mb-2 text-center" style={{ color: "#2c3e50", fontWeight: "600" }}>
                Lending Partner: DMI Finance Private Limited
              </h2>
              <h4 className="text-muted text-center mb-5" style={{ fontWeight: "400" }}>
                DLG Portfolio Details as on July 1st 2026
              </h4>

              <div className="table-responsive">
                <table className="table table-striped table-bordered mt-4 text-center">
                  <thead className="table-dark">
                    <tr>
                      <th scope="col">Cohort</th>
                      <th scope="col">Count of Cohort</th>
                      <th scope="col">Disbursed Amount</th>
                      <th scope="col">Principal Outstanding</th>
                      <th scope="col">FLDG Placed</th>
                      <th scope="col">FLDG Outstanding</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">C1</th>
                      <td>4</td>
                      <td>1,320,824</td>
                      <td>1,196,721</td>
                      <td>66,041</td>
                      <td>66,041</td>
                    </tr>
                    <tr>
                      <th scope="row">C2</th>
                      <td>20</td>
                      <td>6,349,198</td>
                      <td>5,871,566</td>
                      <td>317,460</td>
                      <td>317,460</td>
                    </tr>
                    <tr>
                      <th scope="row">C3</th>
                      <td>178</td>
                      <td>60,113,603</td>
                      <td>59,789,391</td>
                      <td>3,005,680</td>
                      <td>3,005,680</td>
                    </tr>
                    <tr className="table-info fw-bold" style={{ borderTop: "2px solid #000" }}>
                      <th scope="row">Grand Total</th>
                      <td>202</td>
                      <td>67,783,625</td>
                      <td>66,857,678</td>
                      <td>3,389,181</td>
                      <td>3,389,181</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        <div className="row my-5 border-top pt-4 text-center">
          <div className="col-12">
            <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2 gap-md-4">
              <a href="https://www.dmifinance.in/" target="_blank" rel="noopener noreferrer" className="text-decoration-none" style={{ color: "#7225F5", fontWeight: "500" }}>
                DMI Finance Website
              </a>
              <span className="text-muted d-none d-md-inline">|</span>
              <a href="https://www.dmifinance.in/customer-zone/grievance-redressals/" target="_blank" rel="noopener noreferrer" className="text-decoration-none" style={{ color: "#7225F5", fontWeight: "500" }}>
                DMI Finance Grievance Redressal
              </a>
              <span className="text-muted d-none d-md-inline">|</span>
              <a href="https://www.dmifinance.in/privacy-and-security/" target="_blank" rel="noopener noreferrer" className="text-decoration-none" style={{ color: "#7225F5", fontWeight: "500" }}>
                DMI Finance Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DmiPortfolio;
